<template>
    <button
        @click="$emit('click', $event)"
        :disabled="loading"
        type="button"
        class="flex justify-center w-full px-3 py-3 font-bold tracking-tight text-white bg-gray-900 btn pull-xs-right hover:bg-gray-800"
    >
        <span v-if="loading" class="flex" :class="[textColor]">
            <div class="flex">
                {{ text }}
                <base-spinner class="ml-4" />
            </div>
        </span>
        <div v-if="!loading" class="flex">
            <slot></slot>
        </div>
    </button>
</template>

<script>
import BaseSpinner from '@/components/BaseSpinner';

export default {
    name: 'loading-button',
    components: { BaseSpinner },
    props: {
        loading: { type: Boolean },
        text: {
            type: String,
            default: 'Saving...',
        },
        textColor: {
            type: String,
            default: 'text-gray-600',
        },
    },
};
</script>

<style scoped></style>
